function getCurrentStatus(transaction) {
  if (transaction.status === 'OPEN' || transaction.status === 'PENDING') {
    return 'pending';
  }
  if (transaction.status === 'CLOSED') {
    return 'paid';
  }
  if (
    transaction.status === 'CANCELED'
    || transaction.status === 'PROCESSING_CANCEL'
    || transaction.status === 'ABANDONED'
  ) {
    return 'closed';
  }
  return null;
}

function getParsedStatusFromStatus(status) {
  if (status === 'pending') {
    return {
      type: 'warning',
      label: 'Pendente',
    };
  }
  if (status === 'paid') {
    return {
      type: 'success',
      label: 'Quitado',
    };
  }
  if (status === 'closed') {
    return {
      type: 'error',
      label: 'Cancelada',
    };
  }
  return {
    type: '',
    label: '',
  };
}

export default {
  getCurrentStatus,
  getParsedStatusFromStatus,
};
